
import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from 'react'
import CustomPagination from "../../../../../components/custom-pagination/CustomPagination";
import { CASTE_CODES, FEMALE, MALE, NO_RECORDS_FOUND, PRASUTI_KO_STHAN, PRASUTI_KO_TYPES } from "../../../../../utils/constants";
import { AppUtils } from "../../../../../utils/appUtils";
import { AppMisc } from "../../../../../misc/appMisc";
import { NEW_PATIENT, PREVIOUS_PATIENT } from "../../../../../utils/constants/forms";
import { Delete, Done, Edit, Person, Print } from "@mui/icons-material";
import ReactToPrint from "react-to-print";

const StanpaiAamaTathaShishuSewaRegister = ({ totalSize, ...props }) => {
  const [mainRegisterData, setMainRegisterData] = useState([]);
  const tableRef = useRef();

  useEffect(() => {
    if (props.tableData !== null) {
      setMainRegisterData(props.tableData)
    }
  }, [props.tableData])
  return (
    <>
      <ReactToPrint
        trigger={() => (
          <Box display={"flex"} justifyContent={"flex-end"}>
            <IconButton>
              <Print />
            </IconButton>
          </Box>
        )}
        content={() => tableRef.current}
      />
      <TableContainer classes={{ root: "fixed-head-table-container" }}  >
        <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Mul Dartaa Register" ref={tableRef}>
          <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
            <TableRow>
              <TableCell rowSpan={2}>क्र.सं</TableCell>
              <TableCell rowSpan={2}>दर्ता मिति</TableCell>
              <TableCell colSpan={2}>दर्ता नम्बर</TableCell>
              <TableCell colSpan={2}>सेवाग्राहीको</TableCell>
              <Tooltip title=
                {
                  <>
                    {CASTE_CODES.map(caste => (
                      <Typography key={caste.value} variant="caption"> {caste.label} </Typography>
                    ))}
                  </>
                }
                placement="top"
                arrow
              >
                <TableCell rowSpan={2}>जाती कोड</TableCell>
              </Tooltip>
              <TableCell colSpan={2}>उमेर</TableCell>
              <TableCell colSpan={5}>ठेगाना</TableCell>
              <TableCell rowSpan={2}>राष्ट्रिय परिचयपत्र नम्वर</TableCell>
              <TableCell rowSpan={2}>सम्पर्क नम्बर</TableCell>
              <TableCell rowSpan={2}>प्रसुति को मिति</TableCell>
              <TableCell rowSpan={2}>प्रसुति भएको स्थान</TableCell>
              <TableCell rowSpan={2}>प्रसुतिको प्रकार</TableCell>
              <TableCell colSpan={6}>स्वास्थ्य अवस्था</TableCell>
              <TableCell colSpan={2}>प्रेषण भई</TableCell>
              <TableCell rowSpan={2} className="print-none">सम्पादन</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>पहिलो पटक</TableCell>
              <TableCell>थप पटक</TableCell>
              <TableCell>नाम</TableCell>
              <TableCell>थर</TableCell>
              <TableCell>आमा</TableCell>
              <TableCell>शिशु</TableCell>
              <TableCell>जिल्ला</TableCell>
              <TableCell>नगर/गाउँपालिका</TableCell>
              <TableCell>वडा नं.</TableCell>
              <TableCell>टोल</TableCell>
              <TableCell>अन्य मुलुक</TableCell>
              <TableCell>रक्तचाप</TableCell>
              <TableCell>तौल</TableCell>
              <TableCell>मधुमेह</TableCell>
              <TableCell>प्रकृति</TableCell>
              <TableCell>परिक्षण</TableCell>
              <TableCell>अन्य रोग</TableCell>
              <TableCell>आएको संस्थाको नाम</TableCell>
              <TableCell>गएको संस्थाको नाम</TableCell>
            </TableRow>
          </TableHead>
          <TableBody classes={{ root: "align-center" }}>
            {
              mainRegisterData?.length > 0 ? (
                mainRegisterData.map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell>{AppUtils.replaceWithNepaliDigit(index + 1)}</TableCell>
                    <TableCell>{AppMisc.getDateLabelFromMillisecond(row?.dartaaMiti)}</TableCell>
                    <TableCell>{row?.patientType === NEW_PATIENT ? row?.mulDartaaNumber && AppUtils.replaceWithNepaliDigit(row.mulDartaaNumber) : "-"}</TableCell>
                    <TableCell>{row?.patientType === PREVIOUS_PATIENT ? row?.mulDartaaNumber && AppUtils.replaceWithNepaliDigit(row.mulDartaaNumber) : "-"}</TableCell>
                    <TableCell>{row?.patientFirstName || "-"}</TableCell>
                    <TableCell>{row?.patientLastName || "-"}</TableCell>
                    <TableCell>{row?.casteCode && AppUtils.replaceWithNepaliDigit(row.casteCode) || "-"}</TableCell>
                    <TableCell>{row?.gender === FEMALE ? row?.age && AppUtils.replaceWithNepaliDigit(row.age) : "-"}</TableCell>
                    <TableCell>{row?.gender === MALE ? row?.age && AppUtils.replaceWithNepaliDigit(row.age) : "-"}</TableCell>
                    <TableCell>{row?.district && AppMisc.getDistrictName(row?.district)}</TableCell>
                    <TableCell>{row?.palikaName && AppMisc.getMunicipalityName(row?.palikaName)}</TableCell>
                    <TableCell>{row?.wardNumber && AppUtils.replaceWithNepaliDigit(row?.wardNumber)}</TableCell>
                    <TableCell>{row?.gaunOrTole || "-"}</TableCell>
                    <TableCell>{row?.otherCountry ? <Done /> : "-"}</TableCell>
                    <TableCell>{row?.nid || "-"}</TableCell>
                    <TableCell>{row?.phoneNumber && AppUtils.replaceWithNepaliDigit(row?.phoneNumber)}</TableCell>
                    <TableCell>{AppMisc.getDateLabelFromMillisecond(row?.prasutiKoMiti)}</TableCell>
                    <TableCell>{AppMisc.findLabelFromValue(PRASUTI_KO_STHAN, row.prasutiKoStha || "-")}</TableCell>
                    <TableCell>{AppMisc.findLabelFromValue(PRASUTI_KO_TYPES, row.prasutiKoTypes || "-")}</TableCell>
                    <TableCell>{row?.bloodPressure || "-"}</TableCell>
                    <TableCell>{row?.weight || "-"}</TableCell>
                    <TableCell>{row?.diabetes || "-"}</TableCell>
                    <TableCell>{row?.nature || "-"}</TableCell>
                    <TableCell>{row?.examination || "-"}</TableCell>
                    <TableCell>{row?.otherDisease || "-"}</TableCell>
                    <TableCell>{row?.referredIn || "-"}</TableCell>
                    <TableCell>{row?.referredOut || "-"}</TableCell>
                    <TableCell className="print-none">
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <IconButton aria-label="edit" onClick={() => props.onEditRow(row.id)}>
                          <Edit fontSize="small" />
                        </IconButton>
                        <Tooltip title="रेकर्ड हटाउन यहा क्लिक गर्नुहोस" placement="top" arrow>
                          <IconButton onClick={() => props.deleteRow(row.id)}>
                            <Delete fontSize="small" color='secondary' />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="प्रोफाइल कार्ड हेर्न यहा क्लिक गर्नुहोस" placement="top" arrow>
                          <Box>
                            <a target="_blank" rel="noreferrer" href={`stanpai-ama-thatha-shishu-vivaran?id=${row.id}`}>
                              <Person fontSize="small" />
                            </a>
                          </Box>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan="28" size="medium">{NO_RECORDS_FOUND}</TableCell>
                </TableRow>
              )
            }
          </TableBody>
        </Table>
      </TableContainer>
      <CustomPagination
        count={totalSize}
      />
    </>
  )
}

export default StanpaiAamaTathaShishuSewaRegister;